export function Hero () {
  return(
  <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center bg-blue-50/50">
    <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-blue-900 mb-6">
      Bridging Strategy & <span className="text-blue-600">Execution</span>
    </h1>
    <p className="text-xl text-blue-700 max-w-3xl mx-auto mb-10">
      The In-Store Marketing Intelligent Agent (MIA) automates the creation of on-brand, multi-sensory assets by bridging high-level marketing goals with generative AI execution.
    </p>
    <div className="flex flex-wrap justify-center gap-4">
      {[
        { title: 'Signage', sub: 'Visual Generation' },
        { title: 'Audio', sub: 'Sonic Branding' },
        { title: 'Video', sub: 'Motion Assets' },
        { title: 'Smart Cart', sub: 'On-Device Ads' },
        { title: 'Mobile App', sub: 'Loyalty Sync' }
      ].map((item, idx) => (
        <div key={idx} className="bg-white px-6 py-3 rounded-lg shadow-sm border border-blue-200 min-w-[160px]">
          <span className="block text-2xl font-bold text-blue-900">{item.title}</span>
          <span className="text-xs text-blue-500 uppercase tracking-wide">{item.sub}</span>
        </div>
      ))}
    </div>
  </header>
  )
}